// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import * as Utils from './utils/util'
import config from './config'
import store from './store'
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
import '../src/assets/styles/commom.css'
Vue.use(Viewer, {
  defaultOptions: {
    // 需要配置的属性
    button: false,
    navbar: true,
    title: false,
    toolbar: false,
    zoomable: true,
    movable: true,
    scalable: false,
    fullscreen: false
  }
})

console.log(process.env.NODE_ENV)
Vue.use(Antd)
// Vue.use(Viewer)
Vue.config.productionTip = false
Vue.prototype.$utils = Utils
Vue.prototype.$config = config
Vue.prototype.$store = store

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js